import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '@environments/environment';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  TranslateModule,
  TranslateLoader,
  MissingTranslationHandler,
} from '@ngx-translate/core';
import { AppRoutingModule } from 'app/app-routing.module';
import { appInitializerProviders } from 'app/shared/apiInitializerProviders';
import { ApiMissingTranslationHandler } from 'app/shared/apiMissingTranslationHandler';
import { ApiTranslateLoader } from 'app/shared/apiTranslationLoader';
import { httpInterceptorProviders } from 'app/shared/http-interceptors';
import { MaterialModule } from 'app/shared/material/material.module';
import { ChartsModule } from 'ng2-charts';
import { AddClientComponent } from './add-client/add-client.component';
import { AddUsersComponent } from './add-users/add-users.component';
import { AdminClientsComponent } from './admin-clients/admin-clients.component';
import { AdminUsersComponent } from './admin-users/admin-users.component';
import { ApplicationUserTableComponent } from './application-user-table/application-user-table.component';
import { AdminHomeComponent } from './admin-home/admin-home.component';
import { AdminListCameraComponent } from './admin-list-camera/admin-list-camera.component';
import { ApplicationCameraTableComponent } from './application-camera-table/application-camera-table.component';
import { AppCameraWasteTableComponent } from './app-camera-waste-table/app-camera-waste-table.component';
import { CameraOptionComponent } from './camera-option/camera-option.component';
import { ActionComponent } from './action/action.component';
import { AgmCoreModule } from '@agm/core';
import { NotifManagementComponent } from './notif-management/notif-management.component';
import { MonitoringLogsComponent } from './monitoring-logs/monitoring-logs.component';
import { AdminListAnprComponent } from './admin-list-anpr/admin-list-anpr.component';
import { AddLicenseComponent } from './add-license/add-license.component';
import { UpdateLicenseComponent } from './update-license/update-license.component';

registerLocaleData(localeFr, 'fr');

export function tokenGetterFactory(): string {
  return localStorage.getItem(environment.tokenKey);
}

export function TranslateLoaderFactory(http: HttpClient): ApiTranslateLoader {
  return new ApiTranslateLoader(http);
}

@NgModule({
  declarations: [
    ApplicationUserTableComponent,
    AdminUsersComponent,
    AdminClientsComponent,
    AddClientComponent,
    AddUsersComponent,
    AdminHomeComponent,
    AdminListCameraComponent,
    ApplicationCameraTableComponent,
    AppCameraWasteTableComponent,
    CameraOptionComponent,
    ActionComponent,
    NotifManagementComponent,
    MonitoringLogsComponent,
    AdminListAnprComponent,
    AddLicenseComponent,
    UpdateLicenseComponent,
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    MaterialModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyC7Wt3VDl1byLs_VXiNhxq3HKcOwWofB8Y',
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslateLoaderFactory,
        deps: [HttpClient],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: ApiMissingTranslationHandler,
      },
    }),
  ],
  exports: [
    ApplicationUserTableComponent,
    AdminUsersComponent,
    AdminClientsComponent,
    AddClientComponent,
    AddUsersComponent,
    AdminListCameraComponent,
  ],
  providers: [
    appInitializerProviders,
    httpInterceptorProviders,
    { provide: LOCALE_ID, useValue: 'fr' },
  ],
})
export class AdminModule {}
